import { Select, styled } from '@ltvco/refresh-lib/theme';
import { CollectionType } from '@ltvco/refresh-lib/v2';

import { COLLECTION_TYPE_LABELS } from 'components/ChatBV/constants';

type SourceSelectProps = {
  collectionType: CollectionType;
  setCollectionType: (collectionType: CollectionType) => void;
};

const StyledSelect = styled(Select)(({ theme }) => ({
  fontSize: '14px',
  fontWeight: 'bold',
  color: theme.palette.text.secondary,
  borderRadius: '32px',
  width: '200px',
  height: '34px',
  '& .MuiSelect-icon': {
    color: theme.palette.text.secondary,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: theme.palette.text.secondary,
  },
}));

export const SourceSelect = ({
  collectionType,
  setCollectionType,
}: SourceSelectProps) => {
  const sourceOptions = [
    {
      display: `Source: ${
        COLLECTION_TYPE_LABELS[CollectionType.PUBLIC_RECORDS]
      }`,
      value: CollectionType.PUBLIC_RECORDS,
    },
    {
      display: `Source: ${COLLECTION_TYPE_LABELS[CollectionType.OBITUARIES]}`,
      value: CollectionType.OBITUARIES,
    },
    {
      display: `Source: ${
        COLLECTION_TYPE_LABELS[CollectionType.FAMILY_SEARCH]
      }`,
      value: CollectionType.FAMILY_SEARCH,
    },
    {
      display: `Source: ${COLLECTION_TYPE_LABELS[CollectionType.CONTACTS]}`,
      value: CollectionType.CONTACTS,
    },
  ];

  return (
    <StyledSelect
      options={sourceOptions}
      value={collectionType}
      onChange={(event) =>
        setCollectionType(event.target.value as CollectionType)
      }
      id="source-select"
      MenuProps={{
        disablePortal: true,
        disableScrollLock: true,
      }}
    />
  );
};
